const THREE = require('THREE');
require('imports-loader?THREE=THREE!lib/OBJLoader.js');

let objLoader;
let curScene;
const loadingManager = new THREE.LoadingManager();

loadingManager.onProgress = function onProgress(item, loaded, total) {
  console.log(item, loaded, total);
};

// We defer the model loading so that the UI can be rendered first.
const modelLoadingDeferred = {
  resolve: null
};
modelLoadingDeferred.promise = new Promise((resolve) => {
  modelLoadingDeferred.resolve = resolve;
});

export default {
  get objLoader() {
    if (objLoader == null) {
      objLoader = new THREE.OBJLoader(loadingManager);
    }
    return objLoader;
  },
  get curScene() {
    if (curScene == null) {
      curScene = new THREE.Scene();
    }
    return curScene;
  },
  enableObjLoading() {
    modelLoadingDeferred.resolve();
  },
  loadObj(url) {
    return modelLoadingDeferred.promise.then(() => {
      return new Promise((resolve) => {
        this.objLoader.load(url, (obj) => {
          resolve(obj);
        });
      });
    });
  },
  degreeToRadian(degree) {
    return Math.PI * (degree / 180);
  },
  getBoundingBoxOfModelSelf(model) {
    const box = new THREE.Box3();

    model.children.forEach((child) => {
      if (child instanceof THREE.Mesh) {
        if (!child.geometry.boundingBox) {
          child.geometry.computeBoundingBox();
        }
        box.union(child.geometry.boundingBox);
      }
    });

    // Convert the box to the world space
    const points = [
      model.localToWorld(new THREE.Vector3(box.min.x, box.min.y, box.min.z)),
      model.localToWorld(new THREE.Vector3(box.max.x, box.min.y, box.min.z)),
      model.localToWorld(new THREE.Vector3(box.min.x, box.max.y, box.min.z)),
      model.localToWorld(new THREE.Vector3(box.min.x, box.min.y, box.max.z)),
      model.localToWorld(new THREE.Vector3(box.min.x, box.max.y, box.max.z)),
      model.localToWorld(new THREE.Vector3(box.max.x, box.max.y, box.min.z)),
      model.localToWorld(new THREE.Vector3(box.max.x, box.min.y, box.max.z)),
      model.localToWorld(new THREE.Vector3(box.max.x, box.max.y, box.max.z))
    ];

    return new THREE.Box3().setFromPoints(points);
  }
};



// WEBPACK FOOTER //
// ./src/services/three-js-service.js